// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"8c699ed1","41":"f4494df0","91":"ada29fa6","303":"76fa850e","415":"72dc7ae3","453":"08fe3ea2","953":"70c2561c"}[chunkId] + ".chunk.js";
};